export const environment = {
  production: false,
  schedulePollInterval: 5,
  scheduleApiEndpoint: "https://api-dev.palanga.live/live-info-v2?shows=7",
  logoApiEndpoint: "https://api-dev.palanga.live/show-logo",
  streamOgaUrl: "https://stream.palanga.live/palanga128.ogg",
  streamMp3Url: "https://stream.palanga.live/palanga128.mp3",
  //cmsUrl: "http://172.17.0.1:8000/api",
  cmsUrl: 'https://cms-dev.palanga.live/api',
  //cmsUrl: 'https://cms.palanga.live/api',
  apiHost: "https://api.palanga.live/",
  soundcloudClientId: "AAy9HJE4OtIhLoICtebQ",
  soundcloudApiUrl: "https://api.soundcloud.com",
  iOSAppDomain: "ios-dev.palanga.live",

  routes: {
    getInitialData: "/page-data",
    getArchive: "/archive",
    listCoverArts: "/cover-arts",
    getArtistArchive: "/archive/by-artist",
  },
};
